/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/KanbanColumn'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./KanbanColumn'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.KanbanSwimLane = factory(root.BpmbuildUatDsappspotcom.ApiClient, root.BpmbuildUatDsappspotcom.KanbanColumn);
  }
}(this, function(ApiClient, KanbanColumn) {
  'use strict';

  /**
   * The KanbanSwimLane model module.
   * @module model/KanbanSwimLane
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>KanbanSwimLane</code>.
   * @alias module:model/KanbanSwimLane
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>KanbanSwimLane</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/KanbanSwimLane} obj Optional instance to populate.
   * @return {module:model/KanbanSwimLane} The populated <code>KanbanSwimLane</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('columnList'))
        obj.columnList = ApiClient.convertToType(data['columnList'], [KanbanColumn]);
      if (data.hasOwnProperty('sequence'))
        obj.sequence = ApiClient.convertToType(data['sequence'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/KanbanColumn>} columnList
   */
  exports.prototype.columnList = undefined;

  /**
   * @member {Number} sequence
   */
  exports.prototype.sequence = undefined;

  /**
   * @member {String} title
   */
  exports.prototype.title = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/KanbanSwimLane.js